(function () {
  if (window.__nutriHome) { window.__nutriHome(); return; }

  function initSlider(root) {
    if (root.__nutri) return;
    root.__nutri = true;
    var list = root.querySelector('.slick-list');
    if (!list) return;
    var slides = list.querySelectorAll('.slick-slide');
    var dotsWrap = root.querySelector('[data-nutri-dots]');
    var prev = root.querySelector('[data-nutri-prev]');
    var next = root.querySelector('[data-nutri-next]');
    var counter = root.querySelector('[data-nutri-current]');

    function step() { return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : list.clientWidth; }
    function pages() {
      var perView = Math.max(1, Math.round(list.clientWidth / step()));
      return Math.max(1, slides.length - perView + 1);
    }
    function index() { return Math.round(list.scrollLeft / step()); }
    function go(i) {
      var n = pages();
      i = (i + n) % n;
      list.scrollTo({ left: i * step(), behavior: 'smooth' });
    }
    function renderDots() {
      if (!dotsWrap) return;
      var n = pages(), html = '<ul class="slick-dots">';
      for (var i = 0; i < n; i++) html += '<li><button type="button" aria-label="Slide ' + (i + 1) + '"></button></li>';
      dotsWrap.innerHTML = html + '</ul>';
      dotsWrap.querySelectorAll('li').forEach(function (li, i) { li.addEventListener('click', function () { go(i); }); });
      update();
    }
    function update() {
      var i = Math.min(index(), pages() - 1);
      if (dotsWrap) dotsWrap.querySelectorAll('li').forEach(function (li, k) { li.classList.toggle('slick-active', k === i); });
      if (counter) counter.textContent = String(i + 1);
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      root.dispatchEvent(new CustomEvent('nutri:slide', { detail: i }));
    }
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    list.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', renderDots);
    root.__nutriGo = go;
    renderDots();
    var start = parseInt(root.getAttribute('data-nutri-start') || '0', 10);
    if (start) list.scrollLeft = start * step();
  }

  function initFaq(root) {
    if (root.__nutri) return;
    root.__nutri = true;
    var q = root.querySelector('.nx-question'), a = root.querySelector('.nx-answer');
    if (!q || !a) return;
    q.setAttribute('aria-expanded', 'false');
    q.addEventListener('click', function () {
      var open = a.style.display !== 'none';
      a.style.display = open ? 'none' : 'flex';
      q.setAttribute('aria-expanded', String(!open));
      root.classList.toggle('is-open', !open);
    });
  }

  function init() {
    document.querySelectorAll('[data-nutri-slider]').forEach(initSlider);
    document.querySelectorAll('[data-nutri-faq]').forEach(initFaq);
  }

  window.__nutriHome = init;
  window.__nutriInitSlider = initSlider;
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
